import { from } from 'rxjs'

import { store } from 'apps/containers/App/AppContainer'

import StateObserver from './StateObserver'

const storeSubscriber = ({
    checks = [],
    timeout,
}) => new Promise((resolve, reject) => {
    let subscription

    try {
        const state$ = from(store)

        subscription = state$
            .subscribe(
                StateObserver({
                    checks,
                    getSubscription: () => subscription,
                    endSubscription: () => {
                        if (subscription) {
                            subscription.unsubscribe()
                        }
                    },
                    reject,
                    resolve,
                    timeout,
                }),
            )
    } catch (error) {
        if (subscription) {
            subscription.unsubscribe()
        }

        reject(error)
    }
})

export default storeSubscriber
